import { debuggerService } from "../services/DebuggerService";
import { LogSessionRequest } from "../types/debuggerServiceTypes";
import { useAuth } from "../providers/AuthContext";
import { useMessages } from "../providers/MessagesContext";
import { getCurrentPSTDateTime, getCurrentSessionId } from "../utils/apiUtils";

export const useLogTermsAccepted = () => {
  const { getUserEmail } = useAuth();
  const { setSessionCreateTime } = useMessages();

  // Return a function that can be called from event handlers
  const logTermsAccepted = () => {
    // log in session table the date time that user accepted terms
    try {
      const sessionId = getCurrentSessionId();
      const userEmail = getUserEmail();
      const sessionCreateTime = getCurrentPSTDateTime();
      setSessionCreateTime(sessionCreateTime); // session create time is when the user accepted the terms

      const logSessionRequest: LogSessionRequest = {
        session_id: sessionId,
        user_email: userEmail,
        session_create_time: sessionCreateTime,
        terms_accepted: true,
      };

      debuggerService.logSession(logSessionRequest);
    } catch (error) {
      console.error("Failed to log session:", error);
    }
  };

  return logTermsAccepted;
};
